import React, { useState } from "react";
import BuyerManagement from "./BuyerManagement";
import SellerManagement from "./SellerManagement";

const AdminUsers = () => {
  const [tab, setTab] = useState("SELLERS");

  // --- DESIGN STYLES ---
  const subNavStyle = {
    background: "#f3f4f6",
    padding: "10px 40px",
    display: "flex",
    gap: "10px",
    borderBottom: "1px solid #e5e7eb",
    overflowX: "auto",
    whiteSpace: "nowrap"
  };

  const getSubTabStyle = (isActive) => ({
    padding: "6px 20px",
    fontSize: "13px",
    fontWeight: "600",
    borderRadius: "6px",
    border: "none",
    cursor: "pointer",
    transition: "all 0.2s",
    backgroundColor: isActive ? "#ffffff" : "transparent",
    color: isActive ? "#112347" : "#6b7280",
    boxShadow: isActive ? "0 2px 4px rgba(0,0,0,0.05)" : "none",
  });

  return (
    <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
      
      {/* SUB-NAVBAR (Seller / Buyer buttons) */}
      <div style={subNavStyle}>
        <button
          style={getSubTabStyle(tab === "SELLERS")}
          onClick={() => setTab("SELLERS")}
        >
          Seller
        </button>
        <button
          style={getSubTabStyle(tab === "BUYERS")}
          onClick={() => setTab("BUYERS")}
        >
          Buyer
        </button>
      </div>

      {/* CONTENT AREA */}
      <div style={{ padding: "clamp(15px, 4vw, 40px)" }}>
        {tab === "SELLERS" && <SellerManagement />}
        {tab === "BUYERS" && <BuyerManagement />}
      </div>
    </div>
  );
};

export default AdminUsers;